import React from 'react'
import { IconButton, Icon } from 'rsuite'

export default function PreviewButton({ onClick, children = 'Preview', disabled, ...props }) {
  return (
    <IconButton
      appearance="ghost"
      style={{
        marginRight: 10,
        marginBottom: 10,
      }}
      onClick={onClick}
      icon={<Icon appearance="ghost" icon="eye" className="bt-gost-icon-radius" />}
      disabled={disabled}
      {...props}
    >
      {children}
    </IconButton>
  )
}
